import { IMessageSentEvent } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

export async function handleMessageSent(data: IMessageSentEvent): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return;
  }

  group.userTyping.remove(data.userId);
}
